import { RentalListing } from '../entity'

export const findOwner = (listing: RentalListing) => {
  return listing?.listingOperators?.find((o) => o.role === 'OWNER')
}
